"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Promise based timeout delay
 *
 * @param {number} ms Milisecond delay
 * @return {Promise<void>}
 * @example
 *
 * await delay(100);
 */

function delay(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms);
  });
}

exports.delay = delay;